<script setup>
    const {modalClass = null, modalStyle = null} = defineProps({
        buttonText: String,
        title: String,
        isCircle: Boolean,
        modalClass: String,
        modalStyle: [String, Object],
				isOverlayShown: Boolean,
				overlayText: String
    })

    let modelValue = defineModel()
    
    const emits = defineEmits(['click']);

    function onClick(){
        modelValue.value = true;
        emits('click');
    }

    function modalClick(){  
        modelValue.value = false;
    }
</script>

<template>
    <div>
        <div v-if="isCircle">
            <div class="bg-primary d-flex justify-content-center align-items-center rounded-circle" style="width: 30px; height: 30px; cursor: pointer;" @click="onClick">
              <i :class="'bi text-white ' + buttonText" style="font-size: 15px;"></i>
            </div>
        </div>
        <div v-else>
            <button type="button" class="btn btn-primary" @click="onClick">
                {{buttonText}}
            </button>
        </div>
        <Teleport to="body">
            <transition name="fade" mode="out-in">
            <div v-show="modelValue" class="modal show" id="bootstrapModal" tabindex="-1">
                <div class="modal-dialog" :class="modalClass ? modalClass : 'modal-lg'" :style="modalStyle">
                    <div class="modal-content">
											<div v-if="isOverlayShown" id="overlay" class="overlay">
												<div class="spinner-border text-light" role="status">
													<span class="sr-only"></span>
												</div>
												<p class="text-light">{{ overlayText }}</p>
											</div>
											<div class="modal-header text-white" style="background: linear-gradient(180deg, #183548 0%, #183548 50.79%, #364E68 94.06%);">
													<h5 class="modal-title text-center">{{title}}</h5>
													<button type="button" class="btn-close btn-close-white" @mousedown="modalClick"></button>
											</div>
											<div class="modal-body">
													<slot></slot>
											</div>
                    </div>
                </div>
            </div>
            </transition>
        </Teleport>
    </div>
</template>

<style scoped>
    .modal{
        position: fixed;
        inset: 0;
        z-index: 1055;
    }
    .modal-title{
        width: 100%;
        margin: auto;
        font-size: 18px !important;
        font-weight: 500 !important;
    }
    .show{
        background-color: rgba(0, 0, 0, 0.5);
        display: block;
    }

    .fade-leave-active{
        transition: opacity 0s;
    }
		.overlay {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный чёрный фон */
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			z-index: 1050; /* выше чем у модального окна */
		}
</style>
